import {baseGetData, basePostData} from "../../BaseApi";
import getApiBaseUrl from "@/core/getApiBaseUrl";

const URL = getApiBaseUrl();

export const getProfileInfoApi = async () => {
    return await baseGetData(URL + `/profile/info`)
}


export const updateProfileInfoApi = async (data = {fullname: ""}) => {
    return await basePostData(URL + `/profile/update`, JSON.stringify(data));
}

export const setNewPasswordApi = async (data = {
    mobile: "",
    code: "",
    password: "",
    repeat_password: ""
}) => {
    return await basePostData(URL + `/account/password/update`, JSON.stringify(data));
}